import React from 'react';
// After this code is moved out to DPC, we can drop this import and uncomment the implementation.
// eslint-disable-next-line @dropbox/sign/isolate-folder
import * as baseFeatureFlags from 'js/sign-components/common/feature-flag';

export type SignerAppFeatureFlags = Partial<{
  /* eslint-disable camelcase */
  // this looks odd maybe but signature modal is used outside of the signer, too
  sign_core_20240330_new_signer_app: boolean;
  sign_core_2025_11_20_text_field_scaling: boolean;
  sign_core_2025_12_22_increased_attachment_size_limit: boolean;
  sign_core_2025_02_25_new_upload_signature_component: boolean;
  sign_core_2026_03_02_fix_finalize_saving_race: boolean;
  sign_core_2026_03_04_prefill_fields: boolean;
  sign_core_2026_03_03_fix_group_requirement_invariant: boolean;
  sign_core_2026_03_05_log_malformed_group_requirement: boolean;
  /* eslint-enable camelcase */
}>;

// const {
//   useContext: useFeatureFlags,
//   Provider,
// } = createSimpleDataContext<SignerAppFeatureFlags>('FeatureFlags');

export function FeatureFlagProvider({
  children,
  featureFlags,
}: React.PropsWithChildren<{ featureFlags: SignerAppFeatureFlags }>) {
  return (
    <baseFeatureFlags.FeatureFlagProvider featureFlags={featureFlags as any}>
      {children}
    </baseFeatureFlags.FeatureFlagProvider>
  );
}

export function useFeatureFlag(name: keyof SignerAppFeatureFlags) {
  return baseFeatureFlags.useFeatureFlag(name);
  // const context = useFeatureFlags();
  // return Boolean(context[name]);
}
